angular.module('bribac.views.singleOrganization', [
  'ngRoute',
  'ui.bootstrap',
  'bribac.values',
  'bribac.services.routeAuth',
  'bribac.services.api',
  'bribac.services.saveBlobAsFile',
  'bribac.services.filterUtils',
  'bribac.components.whenLoaded',
  'bribac.components.organizationDetails',
  'bribac.components.ibacDetailsExtended',
  'bribac.components.filterActive'
])

  .config(function(
    $routeProvider
  ) {
    $routeProvider.when('/organization/:id', {
      templateUrl: 'single-organization-view.html',
      controller: 'SingleOrganizationViewCtrl',
      controllerAs: '$ctrl',
      resolve: {access: function(routeAuth) {return routeAuth.requireAuth()}}
    })
  })

  .controller('SingleOrganizationViewCtrl', function(
    $routeParams,
    $scope,
    $filter,
    state,
    api,
    saveBlobAsFile,
    filterUtils,
    KINDS
  ) {

    var $ctrl = this

    $ctrl.currentPage = 1
    $ctrl.pageSize = 10
    $ctrl.total = 0

    var organizationId = parseInt($routeParams.id)

    if (!isFinite(organizationId)) {
      // TODO: Should show 404 error instead. Should probably do this check in the $routeProvider config.
      return
    }

    $ctrl.filter = 'active'

    $ctrl.report = {
      organization: {id: organizationId}
    }

    $ctrl.reportOptions = {
      startDate: {initDate: null},
      endDate: {}
    }

    $ctrl.datePickerOpen = {
      startDate: false,
      endDate: false
    }

    $ctrl.reportTypes = [
      {i18n: "views.singleOrganization.ibacUsageReport", apiMethod: "ibacUsage"},
      {i18n: "views.singleOrganization.subjectUsageReport", apiMethod: "subjectUsage"},
      {i18n: "views.singleOrganization.invoiceReport", apiMethod: "invoice"},
      {i18n: "views.singleOrganization.invoiceDetailsReport", apiMethod: "invoiceDetails"},
    ]

    function resetForm($form) {
      if ($form) {
        $ctrl.reportType = null
        $form.$setUntouched()
        $form.$setPristine()
      }
    }

    $ctrl.onReportSubmit = function () {
      var $form = $ctrl.reportForm

      if ($form._submitting) return
      if ($form.$invalid) {
        $form._submitError = 'formErrors.invalidFields'
        return
      }

      $form._submitSuccess = ''
      $form._submitError = ''
      $form._submitting = true

      var parameters = angular.copy($ctrl.report);
      var isoStringMillisecondsRegex = /\.\d{3}/
      parameters.startDate = $ctrl.report.startDate.toISOString().replace(isoStringMillisecondsRegex, '')
      parameters.endDate = $ctrl.report.endDate.toISOString().replace(isoStringMillisecondsRegex, '')

      api.report($ctrl.reportType.apiMethod, parameters)
        .finally(function() { $form._submitting = false })
        .then(
          function success(request) {
            var blob = new Blob([request.data], {type: request.headers()['content-type']})
            var fileName = $ctrl.organization.name +
              ' - ' + $ctrl.reportType.apiMethod +
              ' - ' + $filter('date')($ctrl.report.startDate, "yyyy-MM-dd") +
              ' - ' + $filter('date')($ctrl.report.endDate, "yyyy-MM-dd") +
              '.xls'
            saveBlobAsFile(blob, fileName)
            resetForm($form)
          },
          function error(request) {
            $form._submitError = request.statusText
          }
        )
    }

    $ctrl.activation = function() {
      if ($ctrl.activating) {
        return
      }

      $ctrl.activating = true
      $ctrl.immediateTestSuccessI18n = ''

      var data = angular.extend({}, $ctrl.organization);
      data.isActive = !$ctrl.organization.isActive

      api['put'](KINDS.ORGANIZATION, data)
        .finally(function() {
          $ctrl.activating = false
        })
        .then(
          function success(request) {
            getOrganizationView()
          },
          function error(request) {
            $ctrl.activationErrorI18n = (request.data && request.data.errorMessage)
              ? request.data.errorMessage
              : (request.statusText || 'Unknown error')
          }
        )
    }

    // Init

    $scope.$watch('$ctrl.report.startDate', function(newVal) {
      $ctrl.reportOptions.endDate.minDate = newVal
    })

    $scope.$watch('$ctrl.report.endDate', function(newVal) {
      $ctrl.reportOptions.startDate.maxDate = newVal
    })

    $ctrl.viewPromise = api.getView('organization', organizationId).then(function(request) {
      $ctrl.organization = request.data
      getIbacs()
    })

    function getOrganizationView() {
      api.getView('organization', organizationId).then(function(request) {
        $ctrl.organization = request.data
      })
    }

    $ctrl.toggleDatePicker = function(picker) {
      $ctrl.datePickerOpen[picker] = !$ctrl.datePickerOpen[picker]
    }

    $scope.$watch('$ctrl.filter', getIbacs)
    $scope.$watch("$ctrl.pageSize", getIbacs);

    $ctrl.onPageChange = function () {
      getIbacs()
    }

    function getIbacs() {
      api.getView(KINDS.IBAC + '?status=' + $ctrl.filter
        + "&organizationId=" + $ctrl.organization.id + "&page=" + $ctrl.currentPage
        + "&size=" + $ctrl.pageSize).then(function (request) {
          $ctrl.ibacs = request.data.list
          $ctrl.total = request.data.total
        })
    }

  })
